import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../Context/AuthContext";

const PublicRoutes = () => {
  const { user, loading } = useAuth();

  if (loading) return <div>Loading...</div>;

  if (user?.role?.name === "admin") {
    return <Navigate to="/admin/home" replace />;
  } else if (user?.role?.name === "superadmin") {
    return <Navigate to="/admin/home" replace />;
  } else if (user?.role?.name === "TRAVEL_ADMIN") {
    return <Navigate to="/travel/home" replace />;
  }

  return <Outlet />;
};

export default PublicRoutes;

